import { memo, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import {
  deleteAllCurrentOthersSnippets,
  deleteAllCurrentPinnedSnippets,
  deleteAllMessage,
  isTransferringAll,
  pinAllCurrentSnippets,
  snippetsTabsValue,
  toggleIsDeletingSnippetsPopupDialog,
  toggleIsTransferringAllSnippetsPopupDialog,
  transferAllMessages,
  unPinAllCurrentSnippets,
} from "rtk-slice"

import { isMobile } from "utils/mediaQuery"

import { Button, ButtonGroup, Paper } from "@mui/material"

import { enqueueSnackbar } from "notistack"

import ConfirmDeletingWarningMessage from "../Confirmation-Messages/ConfirmDeletingWarningMessage"
import ConfirmTransferringAll from "../Confirmation-Messages/ConfirmTransferringAll"

const SnippetsUIBar = () => {
  const dispatch = useDispatch()
  const [allSnippets, setAllSnippets] = useState(false)
  const snippetsTabsValueState = useSelector(snippetsTabsValue)
  const isTransferringAllState = useSelector(isTransferringAll)
  const deleteAllMessageState = useSelector(deleteAllMessage)
  const transferAllMessagesState = useSelector(transferAllMessages)

  const handleMoveAllSnippets = () => {
    if (!snippetsTabsValueState) {
      dispatch(unPinAllCurrentSnippets())
    }
    if (snippetsTabsValueState) {
      dispatch(pinAllCurrentSnippets())
    }
  }

  const handleDeleteAllCurrentSnippets = () => {
    if (!snippetsTabsValueState) {
      dispatch(deleteAllCurrentPinnedSnippets())
    }
    if (snippetsTabsValueState) {
      dispatch(deleteAllCurrentOthersSnippets())
    }
    enqueueSnackbar(
      `All ${
        !snippetsTabsValueState ? "Pinned" : "Others"
      } snippets have been deleted`
    )
  }

  const handleToggleIsTransferringAll = () => {
    dispatch(toggleIsTransferringAllSnippetsPopupDialog())
  }

  const handleToggleIsDeletingSnippetsPopupDialog = () => {
    dispatch(toggleIsDeletingSnippetsPopupDialog())
    setAllSnippets((prev) => !prev)
  }

  return (
    <Paper
      sx={{
        animation: `slide-up 1s ease 300ms backwards;`,

        borderRadius: isMobile() ? "0em" : "0.5em",
        width: isMobile() ? "100%" : "max-content",
        mx: "auto",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        py: "1em",
        px: isMobile() ? "0em" : "10em",
        my: "2em",
        backgroundImage: "none",
        bgcolor: "background.card",
        boxShadow:
          "0px 2px 10px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)",
      }}
    >
      <ButtonGroup
        size="large"
        aria-label="Pin-Unpin-Delete Snippets"
        variant="text"
        className="ui-bar"
      >
        <Button
          onClick={
            !deleteAllMessageState
              ? handleDeleteAllCurrentSnippets
              : handleToggleIsDeletingSnippetsPopupDialog
          }
          color="error"
        >
          delete all
        </Button>
        <Button
          sx={{
            gap: "0.4em",
          }}
          onClick={
            !transferAllMessagesState
              ? handleMoveAllSnippets
              : handleToggleIsTransferringAll
          }
        >
          {!snippetsTabsValueState ? "Un-pin all" : "Pin all"}
        </Button>
      </ButtonGroup>

      {deleteAllMessageState && allSnippets ? (
        <ConfirmDeletingWarningMessage
          type="all"
          setAllSnippets={setAllSnippets}
        />
      ) : null}
      {transferAllMessagesState && isTransferringAllState ? (
        <ConfirmTransferringAll />
      ) : null}
    </Paper>
  )
}

export default memo(SnippetsUIBar)
